import { PaginationProps } from 'antd';
import useCrud from 'hooks/useCrud';
import { useCallback, useState } from 'react';
import { create, del, list, ListParams, listV2 } from 'services/api/assistant.account';

const defaultPage = {
  current: 1,
  pageSize: 10,
  total: 0,
};

function useAccount() {
  const [page, setPage] = useState<PaginationProps>(defaultPage);

  const crud = useCrud({
    readList: useCallback((params: ListParams) => {
      return list(params).then((res) => {
        const { data = [], page: current, pageSize, total } = res;

        setPage({
          current,
          pageSize,
          total,
        });

        return data;
      });
    }, []),
    create,
    update: useCallback((updater: () => Promise<any>) => updater(), []),
    del,
  });

  return {
    page,
    setPage,
    ...crud,
  };
}

export default useAccount;
/**
 * 为了不破坏原有接口，临时过渡v2
 * @returns
 */
export function useAccountV2() {
  const [page, setPage] = useState<PaginationProps>(defaultPage);

  const crud = useCrud({
    readList: useCallback((params: ListParams) => {
      return listV2(params).then((res) => {
        const { data = [], page: current, pageSize, total } = res;

        setPage({
          current,
          pageSize,
          total,
        });

        return data;
      });
    }, []),
    create,
    update: useCallback((updater: () => Promise<any>) => updater(), []),
    del,
  });

  return {
    page,
    setPage,
    ...crud,
  };
}
